import domready from "domready";
import "../elements/navigation--viewport";
domready(function () {
  var topBar = document.querySelector(".top-bar");
  if (topBar) {
    var topBarHeight = topBar.offsetHeight;
    var navigationMain = document.querySelector(".navigation--main");
    var header = document.querySelector(".header");
    var scrollPosition = document.documentElement && document.documentElement.scrollTop || document.body.scrollTop;
    if (header) {
      topBarClasses(scrollPosition);
    } else {
      topBar.classList.add("top-bar--fixed");
      if (navigationMain) {
        navigationMain.classList.add("navigation--fixed");
      }
      return;
    }
    window.addEventListener("scroll", function () {
      var scrollPosition = document.documentElement && document.documentElement.scrollTop || document.body.scrollTop;
      topBarClasses(scrollPosition);
    }, {
      capture: true,
      passive: true
    });
    function topBarClasses(scrollPosition) {
      if (header.offsetHeight > topBarHeight) {
        if (scrollPosition > header.offsetHeight - topBarHeight) {
          topBar.classList.add("top-bar--fixed");
          if (navigationMain) {
            navigationMain.classList.add("navigation--fixed");
          }
        } else {
          topBar.classList.remove("top-bar--fixed");
          if (navigationMain) {
            navigationMain.classList.remove("navigation--fixed");
          }
        }
      } else {
        if (scrollPosition > 128) {
          topBar.classList.add("top-bar--fixed");
          if (navigationMain) {
            navigationMain.classList.add("navigation--fixed");
          }
        } else {
          topBar.classList.remove("top-bar--fixed");
          if (navigationMain) {
            navigationMain.classList.remove("navigation--fixed");
          }
        }
      }
    }
  }
});
